import { Component, OnInit } from '@angular/core';
import { CatalogosService } from '../../../services/catalogos.service';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-lista-entidades',
  templateUrl: './lista-entidades.component.html',
  styleUrls: ['./lista-entidades.component.css'],
})
export class ListaEntidadesComponent implements OnInit {
  data: any[];
  isLoading = true;

  constructor(private CatalogosService: CatalogosService, private routeEntidades: Router) {}

  ngOnInit(): void {
    this.CatalogosService.getEntidadesLista().subscribe(
      (response) => {
        this.isLoading = false;
        this.data = response;
      },
      (error) => {
        console.error('Error al obtener entidadesLista:', error);
        this.isLoading = false;
      }
    );
  }


  irEntidades():void{
    this.routeEntidades.navigate(['/entidades']);
  }

  irAsignar():void{
    this.routeEntidades.navigate(['/usuario-entidad']);
  }

  irUsuarios():void{
    this.routeEntidades.navigate(['/asignaciones']);
  }
}
